import firebase from 'firebase';

import View from '../../../../../_components/view/view.js';
import linkUserTpl from './link-user.tpl.html';
import './link-user.styles.less';

class LinkUserView extends View {

	constructor (data, options) {
		super(linkUserTpl, data, options);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnLinkUser: '.btn-link-user',
			alertSuccess: '.alert-success'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		this.ui.btnLinkUser.click(() => this.linkPlayer());
	}

	linkPlayer() {
		this.options.__player.ref.update({
			userId: this.data.userId,
			photoURL: this.data.photoURL
		})
		.then(() => {
			this.ui.btnLinkUser.addClass('hidden');
			this.ui.alertSuccess.removeClass('hidden');
		});
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
		this.ui.btnLinkUser.off();
	}

}

export default LinkUserView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/players/_modals/link-player-modal/link-user/link-user.view.js